<div class="share-order-wrapper">
  <div class="share-order-container">
    <button mat-icon-button [matTooltip]="'CALC_PAGE.PRINT_VERSION' | translate" (click)="onShareClick('print')">
      <mat-icon>print</mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'CALC_PAGE.SAVE_PDF' | translate" (click)="onShareClick('savePdf')">
      <mat-icon svgIcon="fi_pdf"></mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'CALC_PAGE.SHARE_WHATSAPP' | translate" (click)="onShareClick('whatsapp')">
      <mat-icon svgIcon="fi_whatsapp"></mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'CALC_PAGE.SHARE_EMAIL' | translate" (click)="onShareClick('email')">
      <mat-icon svgIcon="fi_email"></mat-icon>
    </button>
  </div>
</div>
